module.exports = __webpack_public_path__ + "static/media/cutscene-5.96938149.mp4";